/**
 * The one `<audio>` element, reachable without prop-drilling it.
 *
 * ## Why anything needs this
 *
 * The store's `position` is written from `timeupdate`, which fires roughly four
 * times a second. That is exactly right for a clock and a progress bar, and
 * useless for anything drawing at sixty frames a second: a visualiser fed from
 * it moves in four steps per second, which reads as a broken animation rather
 * than as music.
 *
 * `currentTime` on the element itself is continuous. So a frame loop reads the
 * element, and everything else keeps reading the store.
 *
 * ## Why a module rather than context
 *
 * `PlayerHost` mounts the element once, at the root, for the life of the app -
 * so there is exactly one, and a context would be ceremony around a value that
 * never changes. Set to null on unmount so a caller cannot hold a detached
 * element, and every caller has to handle null anyway: the visualiser can be
 * on screen before the element exists.
 */
let element: HTMLAudioElement | null = null;

/** Called by `PlayerHost` and nothing else. */
export function setPlayerElement(next: HTMLAudioElement | null): void {
  element = next;
}

export function playerElement(): HTMLAudioElement | null {
  return element;
}
